module.exports = __webpack_public_path__ + "media/images/bg-announcements-17dbbc044e62335e907f5e81fca74a76.jpg";